import { combineReducers } from 'redux';

import department from './department';

export default combineReducers({
  department,
});